import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('clients', [
    '~FETCH_CLIENTS',
    '~PREPARE_FILTER',
]);

export const ACTION = actions(TYPE);
